import React, { createContext, useMemo, useState } from "react";
import PropTypes from "prop-types";

// Context
export const IOSInputIsFocusedContext = createContext();
IOSInputIsFocusedContext.displayName = "IOS Context";

// hooks
import { useDevices } from "../../useDevices";

// components
import MountingWrapper from "./MountingWrapper";

// component
const IOSInputIsFocusedProvider = ({
    children,
    height = 0,
    isDarkMode = false
}) => {
    const [isOpen, setIsOpen] = useState();
    const { isIOS, setIsIOS } = useDevices();

    const value = useMemo(
        () => ({
            isOpen,
            setIsOpen,
            isDarkMode,
            height,
            isIOS,
            setIsIOS
        }),
        [isOpen, setIsOpen, isDarkMode, height, isIOS, setIsIOS]
    );

    return (
        <IOSInputIsFocusedContext.Provider value={value}>
            <MountingWrapper>{children}</MountingWrapper>
        </IOSInputIsFocusedContext.Provider>
    );
};

export default IOSInputIsFocusedProvider;

// prop-types
IOSInputIsFocusedProvider.propTypes = {
    children: PropTypes.any,
    isDarkMode: PropTypes.bool,
    height: PropTypes.number
};
